
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  comments: { StoryblokComponent },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     console.log(this.blok)
  //   })
  // },
  computed: {
    containerStyles() {
      const styles = {}

      styles.maxWidth = this.getBreakpointValue(this.blok.maxWidth)
      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.padding = this.getBreakpointValue(this.blok.padding)

      return styles
    },
  },
}
